import { assertNumber } from './math.js';
export function historyStatistics(points) {
    const valid = points.filter((point) => Number.isFinite(point.price) && point.price > 0);
    if (!valid.length)
        return null;
    const prices = valid.map((point) => point.price).sort((a, b) => a - b);
    const sum = prices.reduce((total, value) => total + value, 0);
    const average = sum / prices.length;
    const midpoint = Math.floor(prices.length / 2);
    const median = prices.length % 2 ? prices[midpoint] : (prices[midpoint - 1] + prices[midpoint]) / 2;
    const variance = prices.reduce((total, value) => total + (value - average) ** 2, 0) / prices.length;
    const first = valid[0].price;
    const last = valid.at(-1).price;
    return {
        minimum: prices[0],
        maximum: prices.at(-1),
        average,
        median,
        volatilityPercent: average === 0 ? null : (Math.sqrt(variance) / average) * 100,
        changePercent: first === 0 ? null : ((last - first) / first) * 100,
        volume: valid.some((point) => point.volume != null) ? valid.reduce((total, point) => total + (point.volume ?? 0), 0) : null,
    };
}
export function movingAverage(points, window) {
    assertNumber(window, 'Fenster', { min: 1, allowZero: false });
    return points.map((point, index) => {
        const start = Math.max(0, index - window + 1);
        const slice = points.slice(start, index + 1).filter((value) => value.price > 0);
        return { ...point, average: slice.length ? slice.reduce((sum, value) => sum + value.price, 0) / slice.length : null };
    });
}
export function freshness(timestamp, staleAfterMinutes, now = new Date()) {
    if (!timestamp)
        return { state: 'missing', ageMinutes: null };
    const time = new Date(timestamp).getTime();
    if (!Number.isFinite(time))
        return { state: 'missing', ageMinutes: null };
    const ageMinutes = Math.max(0, (now.getTime() - time) / 60_000);
    if (ageMinutes <= staleAfterMinutes / 2)
        return { state: 'current', ageMinutes };
    if (ageMinutes <= staleAfterMinutes)
        return { state: 'older', ageMinutes };
    return { state: 'stale', ageMinutes };
}
export function dataQuality(input) {
    const completeness = Math.min(1, Math.max(0, input.completeness));
    const ageScore = input.ageMinutes == null ? 0 : Math.max(0, 1 - input.ageMinutes / Math.max(1, input.staleAfterMinutes * 2));
    const volumeScore = input.volume == null ? 0.35 : Math.min(1, Math.log10(input.volume + 1) / 4);
    const deviationScore = input.deviationPercent == null ? 0.5 : Math.max(0, 1 - Math.abs(input.deviationPercent) / 100);
    return Math.round((ageScore * 0.35 + completeness * 0.35 + volumeScore * 0.15 + deviationScore * 0.15) * 100);
}
export function opportunityScore(input) {
    const profit = Math.min(1, Math.max(0, input.profit) / 1_000_000);
    const margin = Math.min(1, Math.max(0, input.marginPercent ?? 0) / 50);
    const roi = Math.min(1, Math.max(0, input.roiPercent ?? 0) / 100);
    const quality = Math.min(1, Math.max(0, input.quality) / 100);
    const volatilityPenalty = Math.min(0.5, Math.max(0, input.volatilityPercent ?? 0) / 200);
    return Math.round(Math.max(0, (profit * 0.25 + margin * 0.25 + roi * 0.25 + quality * 0.25 - volatilityPenalty) * 100));
}
//# sourceMappingURL=analytics.js.map